// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.release-check-btn {
  border-radius: 5px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  align-items: center;
  background-color: white;
  border: 1px solid #0669B3;
  color: #0669B3;
  cursor: pointer;
  display: flex;
  justify-content: center;
  min-width: 60px;
  padding: 2px 4px;
}
.release-check-btn input {
  margin-right: 6px;
  transform: scale(1.2);
}
.release-check-btn:hover {
  transform: scale(1.035);
}

.disabled-save-and-complete {
  cursor: not-allowed;
  opacity: 0.5;
}

.release-complete-check-wrapper {
  display: flex;
  justify-content: flex-end;
}

@media only screen and (max-width: 1260px) {
  .release-check-btn {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/ManageTemplateTable.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;ECAI,kBDCsB;ECoBtB,2CAAA;EDlBA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cDwBS;ECvBT,eAAA;EACA,aAAA;EAEA,uBAAA;EACA,eAAA;EACA,gBAAA;AASJ;AARI;EACI,iBAAA;EACA,qBAAA;AAUR;AARI;EACE,uBAAA;AAUN;;AANA;EACI,mBAAA;EACA,YAAA;AASJ;;AANA;EACI,aAAA;EACA,yBAAA;AASJ;;AANA;EACI;IACE,eAAA;EASJ;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.release-check-btn {\n    @include borderRadius(5px);\n    @include shadow();\n    align-items: center;\n    background-color: white;\n    border: 1px solid $pearl-blue;\n    color: $pearl-blue;\n    cursor: pointer;\n    display: flex;\n\n    justify-content: center;\n    min-width: 60px;\n    padding: 2px 4px;\n    input {\n        margin-right: 6px;\n        transform: scale(1.2)\n    }\n    &:hover {\n      transform: scale(1.035);\n    }\n}\n\n.disabled-save-and-complete {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n.release-complete-check-wrapper {\n    display: flex;\n    justify-content: flex-end;\n}\n\n@media only screen and (max-width: 1260px) {\n    .release-check-btn {\n      font-size: 12px;\n    }\n  }\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
